export const ABOUT_URL = 'https://liveshuffle.net';
export const PRIVACY_POLICY_URL = 'https://liveshuffle.net/privacypolicy';
export const APP_STORE_URL = 'https://apps.apple.com/us/app/live-shuffle/id1522631804';
export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.austinbyron.liveShuffleBackground';
